import { isEqual, omit } from "lodash";

import { type IGranularity } from "@north-beam/nb-common";

export function needToSwitchApisCalls<T extends { granularity: IGranularity }>(
  currentState: T,
  prevState?: T,
) {
  if (!prevState) {
    return true;
  }

  const currentStateWithoutGranularity = omit(currentState, [
    "granularity",
    "breakdowns",
    "columnSet",
  ]);
  const prevStateWithoutGranularity = omit(prevState, [
    "granularity",
    "breakdowns",
    "columnSet",
  ]);

  if (!isEqual(currentStateWithoutGranularity, prevStateWithoutGranularity)) {
    return true;
  }

  const currentGranularity = currentState.granularity;
  const prevGranularity = prevState.granularity;
  const campaignOrPlatformGranularitySet = new Set<string>([
    "platform",
    "campaign",
  ]);
  if (
    prevGranularity &&
    currentGranularity &&
    campaignOrPlatformGranularitySet.has(prevGranularity) &&
    campaignOrPlatformGranularitySet.has(currentGranularity)
  ) {
    return false;
  }
  return true;
}
